import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from "moment";
import 'moment/locale/pt-br';
import '../../../node_modules/react-vis/dist/style.css';

import Header from '../../components/Header';
import ModalShiftsVisited from '../../components/modals/ModalShiftsVisited';
import ModalCheckins from '../../components/modals/ModalCheckins';
import ModalCustomersServed from '../../components/modals/ModalCustomersServed';
import ModalSales from '../../components/modals/ModalSales';
import ModalShift from '../../components/modals/ModalShift';
import InputDate from '../../components/inputs/InputDate';

import { Link } from 'react-router-dom';
import dash from '../../assets/images/dash.svg';
import pin2 from '../../assets/images/pin.svg';

import statistics from '../../assets/images/statistics.svg';
import pin3 from '../../assets/images/pin3.svg';
import plusCircle from '../../assets/images/plusCircle.svg';
import shiftsImg from '../../assets/images/shifts.svg';
import user5 from '../../assets/images/user5.svg';
import trophy3 from '../../assets/images/trophy3.svg';
import api from '../../services/api';
import { useParams } from 'react-router';
import { Loading } from '../../components/ResponsiveLoading';


export const AboutBrokers = () => {
  const [showShifts, setShowShifts] = useState(false);
  const [filter, setFilter] = useState({});
  const [updateFilter, setUpdateFilter] = useState(null);
  const [showShiftsVisited, setshowShiftsVisited] = useState(false);
  const [showCheckins, setShowCheckins] = useState(false);
  const [showCustomersServed, setShowCustomersServed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showSales, setShowSales] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [shifts, setShifts] = useState('');
  const [totalShifts, setTotalShifts] = useState(0);
  const [atendimentos, setAtendimentos] = useState(0);
  const [checkins, setCheckins] = useState(0);
  const [diretor, setDiretor] = useState(null);
  const [gerente, setGerente] = useState(null);
  const [plantoesVisitados, setPlantoesVisitados] = useState(0);
  const [regional, setRegional] = useState(null);
  const [superintendente, setSuperintendente] = useState(null);
  const [vendas, setVendas] = useState('');
  const [name, setName] = useState('');

  const { id } = useParams();

  const handleShift = (shifts) => {
    setShowShifts(false);
    let cFilter = filter;
    setShifts(shifts);
    cFilter.plantoes_ids = shifts.join(',');
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
  }

  useEffect(() => {
    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    setStartDate(date);
    setFinalDate(date);
    let filters = {
      date_start: moment(date).format('YYYY-MM-DD'),
      date_end: moment(date).format('YYYY-MM-DD'),
    }
    setFilter(filters);
    getShifts();

    getCorretorInterno(filters);
  }, []);

  useEffect(() => {
    if(updateFilter !== null){
      getCorretorInterno(filter)
    }
  }, [updateFilter]);


  const getCorretorInterno = async (filters = {}) => {
    const { data, status } = await api.get(`corretores/${id}`, {
      params: filters
    });
    console.log(data);
    if (status === 200) {
      setAtendimentos(data.total.atendimentos);
      setCheckins(data.total.checkins);
      setDiretor(data.diretor);
      setGerente(data.gerente);
      setPlantoesVisitados(data.total.plantoes_visitados);
      setRegional(data.regional);
      setSuperintendente(data.superintendente);
      setVendas(data.total.vendas);
      setName(data.apelido);
    }
  }

  const handleDate = (start, final) => {
    let cFilter = filter;
    cFilter.date_start = moment(start).format('YYYY-MM-DD');
    cFilter.date_end = moment(final).format('YYYY-MM-DD');
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
    setStartDate(start);
    setFinalDate(final);
  }
  const getShifts = async () => {
    setLoading(true);
    const { data } = await api.get(`list-plantoes`);
    let totalShifts = 0;
    let s = [];
    data.regionais.map(regional => {
      totalShifts += regional.plantoes.length;
      regional.plantoes.map(plantao => {
        s.push(plantao.id);
      });
    });
    setShifts(s);
    setTotalShifts(totalShifts);
    setLoading(false);
  }

  return (
    <>

      {showShifts &&
        <ModalShift handleClose={() => setShowShifts(false)} handleShift={handleShift} shifts={shifts} />
      }
      {showShiftsVisited &&
        <ModalShiftsVisited type="corretores" id={id} totalPlantoesVisitados={plantoesVisitados} filter={filter} handleClose={() => setshowShiftsVisited(false)}
          title='Plantões visitados pela sua equipe' />
      }
      {showCheckins &&
        <ModalCheckins type="corretores" id={id} totalCheckins={checkins} filter={filter} handleClose={() => setShowCheckins(false)}
          title='Check-ins de seus corretores' date={`${moment(startDate).format('DD/MM/YYYY')} a  ${moment(finalDate).format('DD/MM/YYYY')}`} />
      }
      {showCustomersServed &&
        <ModalCustomersServed plantoesName={shifts.length === totalShifts ? `Todos os plantões` : `${shifts.length}  Produtos Selecionados`} type="corretores" id={id} totalAtendimentos={atendimentos} filter={filter} handleClose={() => setShowCustomersServed(false)}
          title='Clientes atendidos pela sua equipe' date={`${moment(startDate).format('DD/MM/YYYY')} a  ${moment(finalDate).format('DD/MM/YYYY')}`} />
      }
      {showSales &&
        <ModalSales plantoesName={shifts.length === totalShifts ? `Todos os plantões` : `${shifts.length}  Produtos Selecionados`} type="corretores" id={id} totalVendas={vendas} filter={filter} handleClose={() => setShowSales(false)}
          title='Vendas no período' />
      }
      <section id="content">
        <Header icon={<img src={pin2} />} title="Corretores" />
        <div className="pd-37">
        <div className="box-names">
          <h3>{name}</h3>
          <div className="state">{regional ? regional.slug : ''}</div>
        </div>
        <div className="box-btns">
          {gerente &&
            <button>Gerente: <Link to={`/managers/${gerente.id}`}>{gerente.apelido}</Link></button>
          }
          {superintendente &&
            <button>Superintendente: <Link to={`/super/${superintendente.id}`}>{superintendente.apelido}</Link></button>
          }
          {diretor &&
            <button>Diretor: <Link to={`/directors/${diretor.id}`}>{diretor.apelido}</Link></button>
          }
        </div>
        <div className="box light-grey">
          <div className="box-header">
            <div className="box-title">
              <img src={statistics} />
              <div className="box-title-text">
                <h2>Estatísticas</h2>
              </div>
            </div>
            <div className="box-tools">
              <button className="btn-filter" style={{ minWidth: 250 }} onClick={() => setShowShifts(true)}>
                <img src={pin2} /> {shifts.length === totalShifts ? `Todos os plantões` : `${shifts.length}  Produtos Selecionados`}
              </button>
              <InputDate cStartDate={startDate} cFinalDate={finalDate} handleDate={handleDate} />
            </div>
          </div>
          <div className="box-body">
            <Row>
              <Col sm={3}>
                <div className="box-card box-card-shifts box-card-pages">
                  <div className="box-card-body">
                    <div className="group-count">
                      <div className="group-count-shifts colorLightBlue">
                        {loading &&
                          <Loading cWidth={100} cHeight={48} />
                        }
                        {!loading &&
                          <>
                            <img src={shiftsImg} />
                            <span className="n-count">{plantoesVisitados}</span>
                          </>
                        }
                      </div>
                      <span className="desc-count">Plantões visitados</span>
                      <a href="#" onClick={() => setshowShiftsVisited(true)} >
                        <img src={plusCircle} />
                        Ver mais
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={3}>
                <div className="box-card box-card-shifts box-card-pages">
                  <div className="box-card-body">
                    <div className="group-count">
                      <div className="group-count-shifts colorLightBlue">
                        {loading &&
                          <Loading cWidth={100} cHeight={48} />
                        }
                        {!loading &&
                          <>
                            <img src={pin3} />
                            <span className="n-count">{checkins}</span>
                          </>
                        }
                      </div>
                      <span className="desc-count">Check-ins</span>
                      <a href="#" onClick={() => setShowCheckins(true)}>
                        <img src={plusCircle} />
                        Ver mais
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={3}>
                <div className="box-card box-card-shifts box-card-pages">
                  <div className="box-card-body">
                    <div className="group-count">
                      <div className="group-count-shifts colorLightBlue">
                        {loading &&
                          <Loading cWidth={100} cHeight={48} />
                        }
                        {!loading &&
                          <>
                            <img src={user5} />
                            <span className="n-count">{atendimentos}</span>
                          </>
                        }
                      </div>
                      <span className="desc-count">Clientes atendidos</span>
                      <a href="#" onClick={() => setShowCustomersServed(true)}>
                        <img src={plusCircle} />
                        Ver mais
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={3}>
                <div className="box-card box-card-shifts box-card-pages">
                  <div className="box-card-body">
                    <div className="group-count">
                      <div className="group-count-shifts" id="colorGreen">
                        {loading &&
                          <Loading cWidth={100} cHeight={48} />
                        }
                        {!loading &&
                          <>
                            <img src={trophy3} />
                            <span className="n-count">{vendas}</span>
                          </>
                        }
                      </div>
                      <span className="desc-count">Contratos assinados no período</span>
                      <a href="#" onClick={() => setShowSales(true)}>
                        <img src={plusCircle} />
                        Ver mais
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        </div>
      </section >
    </>
  );

}

export default AboutBrokers;